import React from 'react';
import { useParams } from 'react-router-dom';
import Login from './Login';
import { SESSION_GROUP_ONLY_ENTRY } from './constants/entryFlow';

/**
 * Deep link /group/:group — syncs storage, marks group-only entry, then Login (group name first, no course picker).
 * Full links use /group/:group/course/:course/ → GroupChecker.
 */
export default function GroupLoginLanding() {
    const { group } = useParams<{ group: string }>();

    if (group) {
        localStorage.setItem('group', group);
        localStorage.removeItem('course');
        sessionStorage.setItem(SESSION_GROUP_ONLY_ENTRY, '1');
    }

    return <Login />;
}
